module.exports = __webpack_public_path__ + "img/Devices.f656cb15.svg";